import { settings } from './settings.js'

export let endpoints = {
  data: 'pdb/all',

  postToken: 'adb/token',
  postChangePassword: 'adb/p/change_password',

  getHealthConnectionAttamps: 'adb/p/health/connectionAttemps',
  getHealthBlacklistsIPLast: 'adb/p/health/blacklistsIPLast',
  getHealthBlacklistsHostnamesLast: 'adb/p/health/blacklistsHostnamesLast',

  getSimulations: 'adb/p/simulations',
  postSimulations: 'adb/p/simulations',
  putSimulation: 'adb/p/simulations',

  getListeners: 'adb/p/listeners',

  getKeys: 'adb/p/keys',
  postKeys: 'adb/p/keys',
  deleteKey: 'adb/p/keys',

  buykey: 'shop/buykey',
}

export function makeUrl(endpoint) {
  return `${settings.APIBase}${endpoint}`;
}
